import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Event, EventsResult } from '../interfaces';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class EventsDataService {

  private uri: string = `${environment.apiUrl}list-event`;
  private headers:any ;

  constructor(
    private http: HttpClient
  ) {
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth) {
      const token = JSON.parse(jsonAuth)?.token;
      if (token) {
        this.headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin':'*',
          authorization: 'Bearer ' + token,
        });
      } 
    }
  }

  getEvents(): Observable<EventsResult|any> {
    return this.http.get(this.uri + "/all-events");
  }

  addEvent(data: any): Observable<Event|any> {
    return this.http.post(this.uri + '/add', data);
  }

  updateEvent(data: any,id:any): Observable<Event|any> {
    return this.http.post(this.uri + '/update'+ `/${id}`, data);
  }

  deleteEvent(data: Event): Observable<null|any> {
    return this.http.put(this.uri + "/update_active" + `/${data.id}`, "");
  }

}
